// Generated by protoc-gen-vendasta-ts — DO NOT EDIT
/* eslint-disable */
import { defer } from 'rxjs';
import { map } from 'rxjs/operators';
import { addConversationToConversationViewRequestToJson, addMultiParticipantsRequestToJson, addMultiParticipantsResponseFromJson, assignConversationRequestToJson, assignConversationResponseFromJson, cancelAIResponderRequestToJson, createAsyncJobMessageRequestToJson, createAsyncJobMessageResponseFromJson, createConversationRequestToJson, createConversationResponseFromJson, createMessageTemplateRequestToJson, createMessageTemplateResponseFromJson, createMultiMessagesRequestToJson, createWidgetConversationRequestToJson, createWidgetConversationResponseFromJson, createWidgetRequestToJson, createWidgetResponseFromJson, deleteConversationRequestToJson, deleteEventByIdempotencyKeyRequestToJson, deleteEventByIdempotencyKeyResponseFromJson, deleteMessageRequestToJson, deleteMessageTemplateRequestToJson, deleteWidgetRequestToJson, evaluateResponseRequestToJson, exportConversationsRequestToJson, exportConversationsResponseFromJson, getAvailableChannelsForConversationRequestToJson, getAvailableChannelsForConversationResponseFromJson, getAvailableWidgetAssistantsRequestToJson, getAvailableWidgetAssistantsResponseFromJson, getConversationByKeyRequestToJson, getConversationByKeyResponseFromJson, getConversationSummaryRequestToJson, getConversationSummaryResponseFromJson, getConversationViewsRequestToJson, getConversationViewsResponseFromJson, getMessageRequestToJson, getMessageTemplateRequestToJson, getMessageTemplateResponseFromJson, getMultiConversationDetailsRequestToJson, getMultiConversationDetailsResponseFromJson, getMultiConversationDetailsV2RequestToJson, getMultiConversationDetailsV2ResponseFromJson, getMultiConversationMessageCountRequestToJson, getMultiConversationMessageCountResponseFromJson, getMultiEventsRequestToJson, getMultiEventsResponseFromJson, getMultiMessagesRequestToJson, getMultiMessagesResponseFromJson, getMultiParticipantsRequestToJson, getMultiParticipantsResponseFromJson, getMultiWidgetMessagesRequestToJson, getMultiWidgetMessagesResponseFromJson, getMultiWidgetRequestToJson, getMultiWidgetResponseFromJson, getParticipantsByKeyRequestToJson, getParticipantsByKeyResponseFromJson, getWidgetConfigRequestToJson, getWidgetConfigResponseFromJson, getWidgetConversationResponseFromJson, getWidgetRequestToJson, getWidgetResponseFromJson, hideMessageRequestToJson, injectMessageRequestToJson, listCommunicationChannelsInfoRequestToJson, listCommunicationChannelsInfoResponseFromJson, listConversationExportsRequestToJson, listConversationExportsResponseFromJson, listConversationsRequestToJson, listConversationsResponseFromJson, listMessageTemplateRequestToJson, listMessageTemplateResponseFromJson, listMessagesRequestToJson, listMessagesResponseFromJson, listResponseEvaluationsRequestToJson, listResponseEvaluationsResponseFromJson, listWidgetsRequestToJson, listWidgetsResponseFromJson, lookupConversationsRequestToJson, lookupConversationsResponseFromJson, makeToolCallRequestToJson, makeToolCallResponseFromJson, messageFromJson, newInboxLeadCapturedRequestToJson, newInboxLeadCapturedResponseFromJson, receiveMessageRequestToJson, removeConversationFromConversationViewRequestToJson, searchConversationsRequestToJson, searchConversationsResponseFromJson, sendMessageRequestToJson, sendMessageResponseFromJson, sendWidgetMessageRequestToJson, sendWidgetMessageResponseFromJson, setLastSeenRequestToJson, setLastSeenResponseFromJson, setSpamStatusRequestToJson, updateAsyncJobMessageRequestToJson, updateConversationRequestToJson, updateConversationResponseFromJson, updateMessageStatusRequestToJson, updateMessageTemplateRequestToJson, updateMessageTemplateResponseFromJson, updateWidgetRequestToJson, updateWidgetResponseFromJson } from './codec';
import { fetchRpc } from '@vendasta/protos/fetch-transport';
import { getGlobalTransport } from '@vendasta/protos/transport';
export async function sendMessage(request) {
    const raw = await fetchRpc('conversation.v1.ConversationService/SendMessage', sendMessageRequestToJson(request));
    return sendMessageResponseFromJson(raw);
}
export function sendMessage$(request, options) {
    return defer(() => sendMessageWithTransport$(getGlobalTransport(), request, options));
}
export function sendMessageWithTransport$(transport, request, options) {
    return transport
        .post('conversation.v1.ConversationService/SendMessage', sendMessageRequestToJson(request), options)
        .pipe(map(resp => sendMessageResponseFromJson(resp)));
}
export async function getMessage(request) {
    const raw = await fetchRpc('conversation.v1.ConversationService/GetMessage', getMessageRequestToJson(request));
    return messageFromJson(raw);
}
export function getMessage$(request, options) {
    return defer(() => getMessageWithTransport$(getGlobalTransport(), request, options));
}
export function getMessageWithTransport$(transport, request, options) {
    return transport
        .post('conversation.v1.ConversationService/GetMessage', getMessageRequestToJson(request), options)
        .pipe(map(resp => messageFromJson(resp)));
}
export async function listMessages(request) {
    const raw = await fetchRpc('conversation.v1.ConversationService/ListMessages', listMessagesRequestToJson(request));
    return listMessagesResponseFromJson(raw);
}
export function listMessages$(request, options) {
    return defer(() => listMessagesWithTransport$(getGlobalTransport(), request, options));
}
export function listMessagesWithTransport$(transport, request, options) {
    return transport
        .post('conversation.v1.ConversationService/ListMessages', listMessagesRequestToJson(request), options)
        .pipe(map(resp => listMessagesResponseFromJson(resp)));
}
export async function deleteMessage(request) {
    await fetchRpc('conversation.v1.ConversationService/DeleteMessage', deleteMessageRequestToJson(request));
}
export function deleteMessage$(request, options) {
    return defer(() => deleteMessageWithTransport$(getGlobalTransport(), request, options));
}
export function deleteMessageWithTransport$(transport, request, options) {
    return transport
        .post('conversation.v1.ConversationService/DeleteMessage', deleteMessageRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function hideMessage(request) {
    await fetchRpc('conversation.v1.ConversationService/HideMessage', hideMessageRequestToJson(request));
}
export function hideMessage$(request, options) {
    return defer(() => hideMessageWithTransport$(getGlobalTransport(), request, options));
}
export function hideMessageWithTransport$(transport, request, options) {
    return transport
        .post('conversation.v1.ConversationService/HideMessage', hideMessageRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function updateMessageStatus(request) {
    await fetchRpc('conversation.v1.ConversationService/UpdateMessageStatus', updateMessageStatusRequestToJson(request));
}
export function updateMessageStatus$(request, options) {
    return defer(() => updateMessageStatusWithTransport$(getGlobalTransport(), request, options));
}
export function updateMessageStatusWithTransport$(transport, request, options) {
    return transport
        .post('conversation.v1.ConversationService/UpdateMessageStatus', updateMessageStatusRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function createAsyncJobMessage(request) {
    const raw = await fetchRpc('conversation.v1.ConversationService/CreateAsyncJobMessage', createAsyncJobMessageRequestToJson(request));
    return createAsyncJobMessageResponseFromJson(raw);
}
export function createAsyncJobMessage$(request, options) {
    return defer(() => createAsyncJobMessageWithTransport$(getGlobalTransport(), request, options));
}
export function createAsyncJobMessageWithTransport$(transport, request, options) {
    return transport
        .post('conversation.v1.ConversationService/CreateAsyncJobMessage', createAsyncJobMessageRequestToJson(request), options)
        .pipe(map(resp => createAsyncJobMessageResponseFromJson(resp)));
}
export async function updateAsyncJobMessage(request) {
    await fetchRpc('conversation.v1.ConversationService/UpdateAsyncJobMessage', updateAsyncJobMessageRequestToJson(request));
}
export function updateAsyncJobMessage$(request, options) {
    return defer(() => updateAsyncJobMessageWithTransport$(getGlobalTransport(), request, options));
}
export function updateAsyncJobMessageWithTransport$(transport, request, options) {
    return transport
        .post('conversation.v1.ConversationService/UpdateAsyncJobMessage', updateAsyncJobMessageRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function lookupConversations(request) {
    const raw = await fetchRpc('conversation.v1.ConversationService/LookupConversations', lookupConversationsRequestToJson(request));
    return lookupConversationsResponseFromJson(raw);
}
export function lookupConversations$(request, options) {
    return defer(() => lookupConversationsWithTransport$(getGlobalTransport(), request, options));
}
export function lookupConversationsWithTransport$(transport, request, options) {
    return transport
        .post('conversation.v1.ConversationService/LookupConversations', lookupConversationsRequestToJson(request), options)
        .pipe(map(resp => lookupConversationsResponseFromJson(resp)));
}
export async function getConversationByKey(request) {
    const raw = await fetchRpc('conversation.v1.ConversationService/GetConversationByKey', getConversationByKeyRequestToJson(request));
    return getConversationByKeyResponseFromJson(raw);
}
export function getConversationByKey$(request, options) {
    return defer(() => getConversationByKeyWithTransport$(getGlobalTransport(), request, options));
}
export function getConversationByKeyWithTransport$(transport, request, options) {
    return transport
        .post('conversation.v1.ConversationService/GetConversationByKey', getConversationByKeyRequestToJson(request), options)
        .pipe(map(resp => getConversationByKeyResponseFromJson(resp)));
}
export async function createConversation(request) {
    const raw = await fetchRpc('conversation.v1.ConversationService/CreateConversation', createConversationRequestToJson(request));
    return createConversationResponseFromJson(raw);
}
export function createConversation$(request, options) {
    return defer(() => createConversationWithTransport$(getGlobalTransport(), request, options));
}
export function createConversationWithTransport$(transport, request, options) {
    return transport
        .post('conversation.v1.ConversationService/CreateConversation', createConversationRequestToJson(request), options)
        .pipe(map(resp => createConversationResponseFromJson(resp)));
}
export async function updateConversation(request) {
    const raw = await fetchRpc('conversation.v1.ConversationService/UpdateConversation', updateConversationRequestToJson(request));
    return updateConversationResponseFromJson(raw);
}
export function updateConversation$(request, options) {
    return defer(() => updateConversationWithTransport$(getGlobalTransport(), request, options));
}
export function updateConversationWithTransport$(transport, request, options) {
    return transport
        .post('conversation.v1.ConversationService/UpdateConversation', updateConversationRequestToJson(request), options)
        .pipe(map(resp => updateConversationResponseFromJson(resp)));
}
export async function cancelAIResponder(request) {
    await fetchRpc('conversation.v1.ConversationService/CancelAIResponder', cancelAIResponderRequestToJson(request));
}
export function cancelAIResponder$(request, options) {
    return defer(() => cancelAIResponderWithTransport$(getGlobalTransport(), request, options));
}
export function cancelAIResponderWithTransport$(transport, request, options) {
    return transport
        .post('conversation.v1.ConversationService/CancelAIResponder', cancelAIResponderRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function deleteConversation(request) {
    await fetchRpc('conversation.v1.ConversationService/DeleteConversation', deleteConversationRequestToJson(request));
}
export function deleteConversation$(request, options) {
    return defer(() => deleteConversationWithTransport$(getGlobalTransport(), request, options));
}
export function deleteConversationWithTransport$(transport, request, options) {
    return transport
        .post('conversation.v1.ConversationService/DeleteConversation', deleteConversationRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function setSpamStatus(request) {
    await fetchRpc('conversation.v1.ConversationService/SetSpamStatus', setSpamStatusRequestToJson(request));
}
export function setSpamStatus$(request, options) {
    return defer(() => setSpamStatusWithTransport$(getGlobalTransport(), request, options));
}
export function setSpamStatusWithTransport$(transport, request, options) {
    return transport
        .post('conversation.v1.ConversationService/SetSpamStatus', setSpamStatusRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function receiveMessage(request) {
    await fetchRpc('conversation.v1.ConversationService/ReceiveMessage', receiveMessageRequestToJson(request));
}
export function receiveMessage$(request, options) {
    return defer(() => receiveMessageWithTransport$(getGlobalTransport(), request, options));
}
export function receiveMessageWithTransport$(transport, request, options) {
    return transport
        .post('conversation.v1.ConversationService/ReceiveMessage', receiveMessageRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function getMultiMessages(request) {
    const raw = await fetchRpc('conversation.v1.ConversationService/GetMultiMessages', getMultiMessagesRequestToJson(request));
    return getMultiMessagesResponseFromJson(raw);
}
export function getMultiMessages$(request, options) {
    return defer(() => getMultiMessagesWithTransport$(getGlobalTransport(), request, options));
}
export function getMultiMessagesWithTransport$(transport, request, options) {
    return transport
        .post('conversation.v1.ConversationService/GetMultiMessages', getMultiMessagesRequestToJson(request), options)
        .pipe(map(resp => getMultiMessagesResponseFromJson(resp)));
}
export async function createMultiMessages(request) {
    await fetchRpc('conversation.v1.ConversationService/CreateMultiMessages', createMultiMessagesRequestToJson(request));
}
export function createMultiMessages$(request, options) {
    return defer(() => createMultiMessagesWithTransport$(getGlobalTransport(), request, options));
}
export function createMultiMessagesWithTransport$(transport, request, options) {
    return transport
        .post('conversation.v1.ConversationService/CreateMultiMessages', createMultiMessagesRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function getMultiConversationDetails(request) {
    const raw = await fetchRpc('conversation.v1.ConversationService/GetMultiConversationDetails', getMultiConversationDetailsRequestToJson(request));
    return getMultiConversationDetailsResponseFromJson(raw);
}
export function getMultiConversationDetails$(request, options) {
    return defer(() => getMultiConversationDetailsWithTransport$(getGlobalTransport(), request, options));
}
export function getMultiConversationDetailsWithTransport$(transport, request, options) {
    return transport
        .post('conversation.v1.ConversationService/GetMultiConversationDetails', getMultiConversationDetailsRequestToJson(request), options)
        .pipe(map(resp => getMultiConversationDetailsResponseFromJson(resp)));
}
export async function getMultiConversationDetailsV2(request) {
    const raw = await fetchRpc('conversation.v1.ConversationService/GetMultiConversationDetailsV2', getMultiConversationDetailsV2RequestToJson(request));
    return getMultiConversationDetailsV2ResponseFromJson(raw);
}
export function getMultiConversationDetailsV2$(request, options) {
    return defer(() => getMultiConversationDetailsV2WithTransport$(getGlobalTransport(), request, options));
}
export function getMultiConversationDetailsV2WithTransport$(transport, request, options) {
    return transport
        .post('conversation.v1.ConversationService/GetMultiConversationDetailsV2', getMultiConversationDetailsV2RequestToJson(request), options)
        .pipe(map(resp => getMultiConversationDetailsV2ResponseFromJson(resp)));
}
export async function getMultiParticipants(request) {
    const raw = await fetchRpc('conversation.v1.ConversationService/GetMultiParticipants', getMultiParticipantsRequestToJson(request));
    return getMultiParticipantsResponseFromJson(raw);
}
export function getMultiParticipants$(request, options) {
    return defer(() => getMultiParticipantsWithTransport$(getGlobalTransport(), request, options));
}
export function getMultiParticipantsWithTransport$(transport, request, options) {
    return transport
        .post('conversation.v1.ConversationService/GetMultiParticipants', getMultiParticipantsRequestToJson(request), options)
        .pipe(map(resp => getMultiParticipantsResponseFromJson(resp)));
}
export async function searchConversations(request) {
    const raw = await fetchRpc('conversation.v1.ConversationService/SearchConversations', searchConversationsRequestToJson(request));
    return searchConversationsResponseFromJson(raw);
}
export function searchConversations$(request, options) {
    return defer(() => searchConversationsWithTransport$(getGlobalTransport(), request, options));
}
export function searchConversationsWithTransport$(transport, request, options) {
    return transport
        .post('conversation.v1.ConversationService/SearchConversations', searchConversationsRequestToJson(request), options)
        .pipe(map(resp => searchConversationsResponseFromJson(resp)));
}
export async function getMultiConversationMessageCount(request) {
    const raw = await fetchRpc('conversation.v1.ConversationService/GetMultiConversationMessageCount', getMultiConversationMessageCountRequestToJson(request));
    return getMultiConversationMessageCountResponseFromJson(raw);
}
export function getMultiConversationMessageCount$(request, options) {
    return defer(() => getMultiConversationMessageCountWithTransport$(getGlobalTransport(), request, options));
}
export function getMultiConversationMessageCountWithTransport$(transport, request, options) {
    return transport
        .post('conversation.v1.ConversationService/GetMultiConversationMessageCount', getMultiConversationMessageCountRequestToJson(request), options)
        .pipe(map(resp => getMultiConversationMessageCountResponseFromJson(resp)));
}
export async function addMultiParticipants(request) {
    const raw = await fetchRpc('conversation.v1.ConversationService/AddMultiParticipants', addMultiParticipantsRequestToJson(request));
    return addMultiParticipantsResponseFromJson(raw);
}
export function addMultiParticipants$(request, options) {
    return defer(() => addMultiParticipantsWithTransport$(getGlobalTransport(), request, options));
}
export function addMultiParticipantsWithTransport$(transport, request, options) {
    return transport
        .post('conversation.v1.ConversationService/AddMultiParticipants', addMultiParticipantsRequestToJson(request), options)
        .pipe(map(resp => addMultiParticipantsResponseFromJson(resp)));
}
export async function setLastSeen(request) {
    const raw = await fetchRpc('conversation.v1.ConversationService/SetLastSeen', setLastSeenRequestToJson(request));
    return setLastSeenResponseFromJson(raw);
}
export function setLastSeen$(request, options) {
    return defer(() => setLastSeenWithTransport$(getGlobalTransport(), request, options));
}
export function setLastSeenWithTransport$(transport, request, options) {
    return transport
        .post('conversation.v1.ConversationService/SetLastSeen', setLastSeenRequestToJson(request), options)
        .pipe(map(resp => setLastSeenResponseFromJson(resp)));
}
export async function getParticipantsByKey(request) {
    const raw = await fetchRpc('conversation.v1.ConversationService/GetParticipantsByKey', getParticipantsByKeyRequestToJson(request));
    return getParticipantsByKeyResponseFromJson(raw);
}
export function getParticipantsByKey$(request, options) {
    return defer(() => getParticipantsByKeyWithTransport$(getGlobalTransport(), request, options));
}
export function getParticipantsByKeyWithTransport$(transport, request, options) {
    return transport
        .post('conversation.v1.ConversationService/GetParticipantsByKey', getParticipantsByKeyRequestToJson(request), options)
        .pipe(map(resp => getParticipantsByKeyResponseFromJson(resp)));
}
export async function getConversationViews(request) {
    const raw = await fetchRpc('conversation.v1.ConversationService/GetConversationViews', getConversationViewsRequestToJson(request));
    return getConversationViewsResponseFromJson(raw);
}
export function getConversationViews$(request, options) {
    return defer(() => getConversationViewsWithTransport$(getGlobalTransport(), request, options));
}
export function getConversationViewsWithTransport$(transport, request, options) {
    return transport
        .post('conversation.v1.ConversationService/GetConversationViews', getConversationViewsRequestToJson(request), options)
        .pipe(map(resp => getConversationViewsResponseFromJson(resp)));
}
export async function addConversationToConversationView(request) {
    await fetchRpc('conversation.v1.ConversationService/AddConversationToConversationView', addConversationToConversationViewRequestToJson(request));
}
export function addConversationToConversationView$(request, options) {
    return defer(() => addConversationToConversationViewWithTransport$(getGlobalTransport(), request, options));
}
export function addConversationToConversationViewWithTransport$(transport, request, options) {
    return transport
        .post('conversation.v1.ConversationService/AddConversationToConversationView', addConversationToConversationViewRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function removeConversationFromConversationView(request) {
    await fetchRpc('conversation.v1.ConversationService/RemoveConversationFromConversationView', removeConversationFromConversationViewRequestToJson(request));
}
export function removeConversationFromConversationView$(request, options) {
    return defer(() => removeConversationFromConversationViewWithTransport$(getGlobalTransport(), request, options));
}
export function removeConversationFromConversationViewWithTransport$(transport, request, options) {
    return transport
        .post('conversation.v1.ConversationService/RemoveConversationFromConversationView', removeConversationFromConversationViewRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function createWidgetConversation(request) {
    const raw = await fetchRpc('conversation.v1.ConversationService/CreateWidgetConversation', createWidgetConversationRequestToJson(request));
    return createWidgetConversationResponseFromJson(raw);
}
export function createWidgetConversation$(request, options) {
    return defer(() => createWidgetConversationWithTransport$(getGlobalTransport(), request, options));
}
export function createWidgetConversationWithTransport$(transport, request, options) {
    return transport
        .post('conversation.v1.ConversationService/CreateWidgetConversation', createWidgetConversationRequestToJson(request), options)
        .pipe(map(resp => createWidgetConversationResponseFromJson(resp)));
}
export async function getMultiWidgetMessages(request) {
    const raw = await fetchRpc('conversation.v1.ConversationService/GetMultiWidgetMessages', getMultiWidgetMessagesRequestToJson(request));
    return getMultiWidgetMessagesResponseFromJson(raw);
}
export function getMultiWidgetMessages$(request, options) {
    return defer(() => getMultiWidgetMessagesWithTransport$(getGlobalTransport(), request, options));
}
export function getMultiWidgetMessagesWithTransport$(transport, request, options) {
    return transport
        .post('conversation.v1.ConversationService/GetMultiWidgetMessages', getMultiWidgetMessagesRequestToJson(request), options)
        .pipe(map(resp => getMultiWidgetMessagesResponseFromJson(resp)));
}
export async function sendWidgetMessage(request) {
    const raw = await fetchRpc('conversation.v1.ConversationService/SendWidgetMessage', sendWidgetMessageRequestToJson(request));
    return sendWidgetMessageResponseFromJson(raw);
}
export function sendWidgetMessage$(request, options) {
    return defer(() => sendWidgetMessageWithTransport$(getGlobalTransport(), request, options));
}
export function sendWidgetMessageWithTransport$(transport, request, options) {
    return transport
        .post('conversation.v1.ConversationService/SendWidgetMessage', sendWidgetMessageRequestToJson(request), options)
        .pipe(map(resp => sendWidgetMessageResponseFromJson(resp)));
}
export async function getWidgetConversation() {
    const raw = await fetchRpc('conversation.v1.ConversationService/GetWidgetConversation', {});
    return getWidgetConversationResponseFromJson(raw);
}
export function getWidgetConversation$(options) {
    return defer(() => getWidgetConversationWithTransport$(getGlobalTransport(), options));
}
export function getWidgetConversationWithTransport$(transport, options) {
    return transport
        .post('conversation.v1.ConversationService/GetWidgetConversation', {}, options)
        .pipe(map(resp => getWidgetConversationResponseFromJson(resp)));
}
export async function getAvailableChannelsForConversation(request) {
    const raw = await fetchRpc('conversation.v1.ConversationService/GetAvailableChannelsForConversation', getAvailableChannelsForConversationRequestToJson(request));
    return getAvailableChannelsForConversationResponseFromJson(raw);
}
export function getAvailableChannelsForConversation$(request, options) {
    return defer(() => getAvailableChannelsForConversationWithTransport$(getGlobalTransport(), request, options));
}
export function getAvailableChannelsForConversationWithTransport$(transport, request, options) {
    return transport
        .post('conversation.v1.ConversationService/GetAvailableChannelsForConversation', getAvailableChannelsForConversationRequestToJson(request), options)
        .pipe(map(resp => getAvailableChannelsForConversationResponseFromJson(resp)));
}
export async function evaluateResponse(request) {
    await fetchRpc('conversation.v1.ConversationService/EvaluateResponse', evaluateResponseRequestToJson(request));
}
export function evaluateResponse$(request, options) {
    return defer(() => evaluateResponseWithTransport$(getGlobalTransport(), request, options));
}
export function evaluateResponseWithTransport$(transport, request, options) {
    return transport
        .post('conversation.v1.ConversationService/EvaluateResponse', evaluateResponseRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function listResponseEvaluations(request) {
    const raw = await fetchRpc('conversation.v1.ConversationService/ListResponseEvaluations', listResponseEvaluationsRequestToJson(request));
    return listResponseEvaluationsResponseFromJson(raw);
}
export function listResponseEvaluations$(request, options) {
    return defer(() => listResponseEvaluationsWithTransport$(getGlobalTransport(), request, options));
}
export function listResponseEvaluationsWithTransport$(transport, request, options) {
    return transport
        .post('conversation.v1.ConversationService/ListResponseEvaluations', listResponseEvaluationsRequestToJson(request), options)
        .pipe(map(resp => listResponseEvaluationsResponseFromJson(resp)));
}
export async function createWidget(request) {
    const raw = await fetchRpc('conversation.v1.ConversationService/CreateWidget', createWidgetRequestToJson(request));
    return createWidgetResponseFromJson(raw);
}
export function createWidget$(request, options) {
    return defer(() => createWidgetWithTransport$(getGlobalTransport(), request, options));
}
export function createWidgetWithTransport$(transport, request, options) {
    return transport
        .post('conversation.v1.ConversationService/CreateWidget', createWidgetRequestToJson(request), options)
        .pipe(map(resp => createWidgetResponseFromJson(resp)));
}
export async function getWidget(request) {
    const raw = await fetchRpc('conversation.v1.ConversationService/GetWidget', getWidgetRequestToJson(request));
    return getWidgetResponseFromJson(raw);
}
export function getWidget$(request, options) {
    return defer(() => getWidgetWithTransport$(getGlobalTransport(), request, options));
}
export function getWidgetWithTransport$(transport, request, options) {
    return transport
        .post('conversation.v1.ConversationService/GetWidget', getWidgetRequestToJson(request), options)
        .pipe(map(resp => getWidgetResponseFromJson(resp)));
}
export async function getMultiWidget(request) {
    const raw = await fetchRpc('conversation.v1.ConversationService/GetMultiWidget', getMultiWidgetRequestToJson(request));
    return getMultiWidgetResponseFromJson(raw);
}
export function getMultiWidget$(request, options) {
    return defer(() => getMultiWidgetWithTransport$(getGlobalTransport(), request, options));
}
export function getMultiWidgetWithTransport$(transport, request, options) {
    return transport
        .post('conversation.v1.ConversationService/GetMultiWidget', getMultiWidgetRequestToJson(request), options)
        .pipe(map(resp => getMultiWidgetResponseFromJson(resp)));
}
export async function updateWidget(request) {
    const raw = await fetchRpc('conversation.v1.ConversationService/UpdateWidget', updateWidgetRequestToJson(request));
    return updateWidgetResponseFromJson(raw);
}
export function updateWidget$(request, options) {
    return defer(() => updateWidgetWithTransport$(getGlobalTransport(), request, options));
}
export function updateWidgetWithTransport$(transport, request, options) {
    return transport
        .post('conversation.v1.ConversationService/UpdateWidget', updateWidgetRequestToJson(request), options)
        .pipe(map(resp => updateWidgetResponseFromJson(resp)));
}
export async function deleteWidget(request) {
    await fetchRpc('conversation.v1.ConversationService/DeleteWidget', deleteWidgetRequestToJson(request));
}
export function deleteWidget$(request, options) {
    return defer(() => deleteWidgetWithTransport$(getGlobalTransport(), request, options));
}
export function deleteWidgetWithTransport$(transport, request, options) {
    return transport
        .post('conversation.v1.ConversationService/DeleteWidget', deleteWidgetRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function listWidgets(request) {
    const raw = await fetchRpc('conversation.v1.ConversationService/ListWidgets', listWidgetsRequestToJson(request));
    return listWidgetsResponseFromJson(raw);
}
export function listWidgets$(request, options) {
    return defer(() => listWidgetsWithTransport$(getGlobalTransport(), request, options));
}
export function listWidgetsWithTransport$(transport, request, options) {
    return transport
        .post('conversation.v1.ConversationService/ListWidgets', listWidgetsRequestToJson(request), options)
        .pipe(map(resp => listWidgetsResponseFromJson(resp)));
}
export async function getAvailableWidgetAssistants(request) {
    const raw = await fetchRpc('conversation.v1.ConversationService/GetAvailableWidgetAssistants', getAvailableWidgetAssistantsRequestToJson(request));
    return getAvailableWidgetAssistantsResponseFromJson(raw);
}
export function getAvailableWidgetAssistants$(request, options) {
    return defer(() => getAvailableWidgetAssistantsWithTransport$(getGlobalTransport(), request, options));
}
export function getAvailableWidgetAssistantsWithTransport$(transport, request, options) {
    return transport
        .post('conversation.v1.ConversationService/GetAvailableWidgetAssistants', getAvailableWidgetAssistantsRequestToJson(request), options)
        .pipe(map(resp => getAvailableWidgetAssistantsResponseFromJson(resp)));
}
export async function getWidgetConfig(request) {
    const raw = await fetchRpc('conversation.v1.ConversationService/GetWidgetConfig', getWidgetConfigRequestToJson(request));
    return getWidgetConfigResponseFromJson(raw);
}
export function getWidgetConfig$(request, options) {
    return defer(() => getWidgetConfigWithTransport$(getGlobalTransport(), request, options));
}
export function getWidgetConfigWithTransport$(transport, request, options) {
    return transport
        .post('conversation.v1.ConversationService/GetWidgetConfig', getWidgetConfigRequestToJson(request), options)
        .pipe(map(resp => getWidgetConfigResponseFromJson(resp)));
}
export async function listMessageTemplate(request) {
    const raw = await fetchRpc('conversation.v1.ConversationService/ListMessageTemplate', listMessageTemplateRequestToJson(request));
    return listMessageTemplateResponseFromJson(raw);
}
export function listMessageTemplate$(request, options) {
    return defer(() => listMessageTemplateWithTransport$(getGlobalTransport(), request, options));
}
export function listMessageTemplateWithTransport$(transport, request, options) {
    return transport
        .post('conversation.v1.ConversationService/ListMessageTemplate', listMessageTemplateRequestToJson(request), options)
        .pipe(map(resp => listMessageTemplateResponseFromJson(resp)));
}
export async function deleteMessageTemplate(request) {
    await fetchRpc('conversation.v1.ConversationService/DeleteMessageTemplate', deleteMessageTemplateRequestToJson(request));
}
export function deleteMessageTemplate$(request, options) {
    return defer(() => deleteMessageTemplateWithTransport$(getGlobalTransport(), request, options));
}
export function deleteMessageTemplateWithTransport$(transport, request, options) {
    return transport
        .post('conversation.v1.ConversationService/DeleteMessageTemplate', deleteMessageTemplateRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function createMessageTemplate(request) {
    const raw = await fetchRpc('conversation.v1.ConversationService/CreateMessageTemplate', createMessageTemplateRequestToJson(request));
    return createMessageTemplateResponseFromJson(raw);
}
export function createMessageTemplate$(request, options) {
    return defer(() => createMessageTemplateWithTransport$(getGlobalTransport(), request, options));
}
export function createMessageTemplateWithTransport$(transport, request, options) {
    return transport
        .post('conversation.v1.ConversationService/CreateMessageTemplate', createMessageTemplateRequestToJson(request), options)
        .pipe(map(resp => createMessageTemplateResponseFromJson(resp)));
}
export async function updateMessageTemplate(request) {
    const raw = await fetchRpc('conversation.v1.ConversationService/UpdateMessageTemplate', updateMessageTemplateRequestToJson(request));
    return updateMessageTemplateResponseFromJson(raw);
}
export function updateMessageTemplate$(request, options) {
    return defer(() => updateMessageTemplateWithTransport$(getGlobalTransport(), request, options));
}
export function updateMessageTemplateWithTransport$(transport, request, options) {
    return transport
        .post('conversation.v1.ConversationService/UpdateMessageTemplate', updateMessageTemplateRequestToJson(request), options)
        .pipe(map(resp => updateMessageTemplateResponseFromJson(resp)));
}
export async function getMessageTemplate(request) {
    const raw = await fetchRpc('conversation.v1.ConversationService/GetMessageTemplate', getMessageTemplateRequestToJson(request));
    return getMessageTemplateResponseFromJson(raw);
}
export function getMessageTemplate$(request, options) {
    return defer(() => getMessageTemplateWithTransport$(getGlobalTransport(), request, options));
}
export function getMessageTemplateWithTransport$(transport, request, options) {
    return transport
        .post('conversation.v1.ConversationService/GetMessageTemplate', getMessageTemplateRequestToJson(request), options)
        .pipe(map(resp => getMessageTemplateResponseFromJson(resp)));
}
export async function getConversationSummary(request) {
    const raw = await fetchRpc('conversation.v1.ConversationService/GetConversationSummary', getConversationSummaryRequestToJson(request));
    return getConversationSummaryResponseFromJson(raw);
}
export function getConversationSummary$(request, options) {
    return defer(() => getConversationSummaryWithTransport$(getGlobalTransport(), request, options));
}
export function getConversationSummaryWithTransport$(transport, request, options) {
    return transport
        .post('conversation.v1.ConversationService/GetConversationSummary', getConversationSummaryRequestToJson(request), options)
        .pipe(map(resp => getConversationSummaryResponseFromJson(resp)));
}
export async function newInboxLeadCaptured(request) {
    const raw = await fetchRpc('conversation.v1.ConversationService/NewInboxLeadCaptured', newInboxLeadCapturedRequestToJson(request));
    return newInboxLeadCapturedResponseFromJson(raw);
}
export function newInboxLeadCaptured$(request, options) {
    return defer(() => newInboxLeadCapturedWithTransport$(getGlobalTransport(), request, options));
}
export function newInboxLeadCapturedWithTransport$(transport, request, options) {
    return transport
        .post('conversation.v1.ConversationService/NewInboxLeadCaptured', newInboxLeadCapturedRequestToJson(request), options)
        .pipe(map(resp => newInboxLeadCapturedResponseFromJson(resp)));
}
export async function getMultiEvents(request) {
    const raw = await fetchRpc('conversation.v1.ConversationService/GetMultiEvents', getMultiEventsRequestToJson(request));
    return getMultiEventsResponseFromJson(raw);
}
export function getMultiEvents$(request, options) {
    return defer(() => getMultiEventsWithTransport$(getGlobalTransport(), request, options));
}
export function getMultiEventsWithTransport$(transport, request, options) {
    return transport
        .post('conversation.v1.ConversationService/GetMultiEvents', getMultiEventsRequestToJson(request), options)
        .pipe(map(resp => getMultiEventsResponseFromJson(resp)));
}
export async function deleteEventByIdempotencyKey(request) {
    const raw = await fetchRpc('conversation.v1.ConversationService/DeleteEventByIdempotencyKey', deleteEventByIdempotencyKeyRequestToJson(request));
    return deleteEventByIdempotencyKeyResponseFromJson(raw);
}
export function deleteEventByIdempotencyKey$(request, options) {
    return defer(() => deleteEventByIdempotencyKeyWithTransport$(getGlobalTransport(), request, options));
}
export function deleteEventByIdempotencyKeyWithTransport$(transport, request, options) {
    return transport
        .post('conversation.v1.ConversationService/DeleteEventByIdempotencyKey', deleteEventByIdempotencyKeyRequestToJson(request), options)
        .pipe(map(resp => deleteEventByIdempotencyKeyResponseFromJson(resp)));
}
export async function injectMessage(request) {
    await fetchRpc('conversation.v1.ConversationService/InjectMessage', injectMessageRequestToJson(request));
}
export function injectMessage$(request, options) {
    return defer(() => injectMessageWithTransport$(getGlobalTransport(), request, options));
}
export function injectMessageWithTransport$(transport, request, options) {
    return transport
        .post('conversation.v1.ConversationService/InjectMessage', injectMessageRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function makeToolCall(request) {
    const raw = await fetchRpc('conversation.v1.ConversationService/MakeToolCall', makeToolCallRequestToJson(request));
    return makeToolCallResponseFromJson(raw);
}
export function makeToolCall$(request, options) {
    return defer(() => makeToolCallWithTransport$(getGlobalTransport(), request, options));
}
export function makeToolCallWithTransport$(transport, request, options) {
    return transport
        .post('conversation.v1.ConversationService/MakeToolCall', makeToolCallRequestToJson(request), options)
        .pipe(map(resp => makeToolCallResponseFromJson(resp)));
}
export async function exportConversations(request) {
    const raw = await fetchRpc('conversation.v1.ConversationService/ExportConversations', exportConversationsRequestToJson(request));
    return exportConversationsResponseFromJson(raw);
}
export function exportConversations$(request, options) {
    return defer(() => exportConversationsWithTransport$(getGlobalTransport(), request, options));
}
export function exportConversationsWithTransport$(transport, request, options) {
    return transport
        .post('conversation.v1.ConversationService/ExportConversations', exportConversationsRequestToJson(request), options)
        .pipe(map(resp => exportConversationsResponseFromJson(resp)));
}
export async function listConversationExports(request) {
    const raw = await fetchRpc('conversation.v1.ConversationService/ListConversationExports', listConversationExportsRequestToJson(request));
    return listConversationExportsResponseFromJson(raw);
}
export function listConversationExports$(request, options) {
    return defer(() => listConversationExportsWithTransport$(getGlobalTransport(), request, options));
}
export function listConversationExportsWithTransport$(transport, request, options) {
    return transport
        .post('conversation.v1.ConversationService/ListConversationExports', listConversationExportsRequestToJson(request), options)
        .pipe(map(resp => listConversationExportsResponseFromJson(resp)));
}
export async function listCommunicationChannelsInfo(request) {
    const raw = await fetchRpc('conversation.v1.ConversationService/ListCommunicationChannelsInfo', listCommunicationChannelsInfoRequestToJson(request));
    return listCommunicationChannelsInfoResponseFromJson(raw);
}
export function listCommunicationChannelsInfo$(request, options) {
    return defer(() => listCommunicationChannelsInfoWithTransport$(getGlobalTransport(), request, options));
}
export function listCommunicationChannelsInfoWithTransport$(transport, request, options) {
    return transport
        .post('conversation.v1.ConversationService/ListCommunicationChannelsInfo', listCommunicationChannelsInfoRequestToJson(request), options)
        .pipe(map(resp => listCommunicationChannelsInfoResponseFromJson(resp)));
}
export async function listConversations(request) {
    const raw = await fetchRpc('conversation.v1.ConversationService/ListConversations', listConversationsRequestToJson(request));
    return listConversationsResponseFromJson(raw);
}
export function listConversations$(request, options) {
    return defer(() => listConversationsWithTransport$(getGlobalTransport(), request, options));
}
export function listConversationsWithTransport$(transport, request, options) {
    return transport
        .post('conversation.v1.ConversationService/ListConversations', listConversationsRequestToJson(request), options)
        .pipe(map(resp => listConversationsResponseFromJson(resp)));
}
export async function assignConversation(request) {
    const raw = await fetchRpc('conversation.v1.ConversationService/AssignConversation', assignConversationRequestToJson(request));
    return assignConversationResponseFromJson(raw);
}
export function assignConversation$(request, options) {
    return defer(() => assignConversationWithTransport$(getGlobalTransport(), request, options));
}
export function assignConversationWithTransport$(transport, request, options) {
    return transport
        .post('conversation.v1.ConversationService/AssignConversation', assignConversationRequestToJson(request), options)
        .pipe(map(resp => assignConversationResponseFromJson(resp)));
}
